import { IAmendment, IRegulation } from '../../contracts/amendment.contract';

// DateOfAdoption from API: "08/06/2023" (dd/MM/yyyy). Missing/invalid → null (sort last).
export const parseAdoptionDate = (value?: string): Date | null => {
    if (!value?.trim()) return null;
    const [day, month, year] = value.trim().split('/').map(Number);
    if (!day || !month || !year) return null;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    return date;
};

export const sortAmendmentsByAdoptionDate = (amendments: IAmendment[]): IAmendment[] => {
    return [...amendments].sort((a, b) => {
        const aDate = parseAdoptionDate(a.DateOfAdoption);
        const bDate = parseAdoptionDate(b.DateOfAdoption);
        if (aDate && bDate) return bDate.getTime() - aDate.getTime();
        if (aDate) return -1;
        if (bDate) return 1;
        return 0;
    });
};

export const sortRegulationsByAdoptionDate = (regs: IRegulation[]): IRegulation[] => {
    const withSortedAmendments = regs.map((regulation) => ({
        ...regulation,
        Amendments: sortAmendmentsByAdoptionDate(regulation.Amendments ?? [])
    }));

    return withSortedAmendments.sort((a, b) => {
        const aDate = parseAdoptionDate(a.Amendments[0]?.DateOfAdoption);
        const bDate = parseAdoptionDate(b.Amendments[0]?.DateOfAdoption);
        if (aDate && bDate) {
            const byDate = bDate.getTime() - aDate.getTime();
            if (byDate !== 0) return byDate;
        } else if (aDate) {
            return -1;
        } else if (bDate) {
            return 1;
        }
        return (a.RegulationName || '').localeCompare(b.RegulationName || '');
    });
};
